import {
    DEALERBANKNAME_SUCCESS,
    DEALERBANKNAME_FAILED,
    RESET_DEALERBANKNAME,
    LOADING_DEALERBANKNAME,
    NETWORK_ERROR_DEALERBANKNAME
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERBANKNAME:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERBANKNAME_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERBANKNAME_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERBANKNAME:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERBANKNAME:
            return (state = initialState);
        default:
            return state;
    }
};
